import { create } from "zustand";
import { persist } from "zustand/middleware";

type ActiveState = {
  workspaceId: string | null;
  brandId: string | null;
  set: (workspaceId: string | null, brandId: string | null) => void;
};

/**
 * The workspace and brand being worked on, remembered across reloads. Every API call sends them
 * as X-Workspace-Id / X-Brand-Id (lib/api.ts); the server checks membership on each request.
 */
export const useActiveStore = create<ActiveState>()(
  persist(
    (set) => ({
      workspaceId: null,
      brandId: null,
      set: (workspaceId, brandId) => set({ workspaceId, brandId }),
    }),
    { name: "growth-active" },
  ),
);
